<script setup>
const emit = defineEmits(["signupClick"]);

const props = defineProps({
  headline: String,
  trumpet: String,
  subHeading: String,
});
const { isMobileOrTablet } = useDevice();
const { width: innerWidth } = useWindowSize();

const isMobile = computed(() => {
  if (process.server) return isMobileOrTablet;
  return innerWidth.value < 900;
});
const currentTheme = ref(null);

const signupClick = () => {
  emit("signupClick");
};

onMounted(() => {
  const { getCurrentTheme } = useTheme();
  nextTick(() => {
    currentTheme.value = getCurrentTheme();
  });
});
</script>

<template>
  <div class="flex w-screen md:h-[calc(100vh-4.5rem)] md:w-full md:pb-bleed">
    <div
      :data-section-theme="isMobile ? 'dark' : 'light'"
      :class="`flex w-full flex-col items-start px-bleed pb-bleed pt-32 md:max-h-[calc(100vh-4.5rem)] md:p-5 bg-${currentTheme} text-${currentTheme}-text`"
    >
      <div class="mb-auto mt-auto grid gap-4 md:grid-cols-6">
        <ui-font-text type="xs" class="opacity-50 md:col-span-5">
          {{ trumpet }}
        </ui-font-text>

        <h1 class="pb-6 text-xl md:col-span-5 md:pb-0">
          <span v-html="headline"></span>
        </h1>
        <ui-font-text type="s" class="md:col-span-5">
          {{ subHeading }}
        </ui-font-text>
      </div>
      <div class="signup-wrapper mt-10">
        <ui-call-to-action
          :button="true"
          :is-big="true"
          :has-background="true"
          aria-label="Apply button"
          :invert-background="true"
          class="mt-10"
          @click="signupClick"
        >
          <ui-font-text type="s">
            {{ formatCTALabel("Apply") }}
          </ui-font-text>
        </ui-call-to-action>
      </div>
    </div>
  </div>
</template>

<style></style>
